
        var result = require("!!../../../node_modules/css-loader/index.js!./footer.component.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.css
// module id = 723
// module chunks = 0